import React, {useState} from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { storage } from '../../helpers/storage';

const InfoCheck = ({code, folio}) => {
    const navigate = useNavigate();

    console.log(code, folio);
    const [showAviso, setShowAviso] = useState({});
    const [getData, setData] = useState(null);

    const handleGetInfo = (folio) => {
        helpHttp().post(`${BASE_API}Entrega/SpdRelAlumnoValidXFolio`, {
            body: {
               "Folio": folio
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if(res.SUCCESS) {
                setData(res.ITEMS);
                setShowAviso({show: true});
            } else {
                //setData(null);
                //setError(true);
            }
            //setLoading(false);
        });
    }

    return (
        <>
            <Button 
                label={(code ===2 ? "Aprobado": "Rechazado")} 
                icon={`pi ${(code ===2 ? "pi-check": "pi-times")}`} 
                className="p-button-rounded p-button-success mr-2 mb-2" 
                onClick={() => handleGetInfo(folio)}
            />

            <Dialog header="Revisión" visible={showAviso.show} style={{ width: '30vw' }} modal onHide={() => setShowAviso(false)}>
                <div className="col-12">
                    <div className="p-3 h-full">
                        <div className="shadow-2 p-3 h-full flex flex-column surface-card" style={{ borderRadius: '6px' }}>
                            <div className="text-900 font-medium text-xl mb-2">FOLIO: {getData?.Folio}</div>
                            <div className="text-900">ALUMNO: {getData?.Nombre} {getData?.ApellidoPaterno} {getData?.ApellidoMaterno}</div>
                            <div className="text-900">CURP: {getData?.CURP}</div>
                            <div className="text-900">COMENTARIO: {getData?.Comentario}</div>

                            

                            
                        </div>
                    </div>
                </div>
                <div className="col-12">
                    <div className="d-grid gap-2" >
                        <Link to={`#/resumen/${window.btoa(getData?.IdAlumno)}`} target="_blank" style={{marginLeft: "auto", marginRight: "auto"}}>
                        <button class="btn btn-primary" type="button">Ver Comprobante</button>
                        </Link>
                    </div>
                </div>
            </Dialog>
        </>
        
    );
}

export default InfoCheck;